var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Success icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photos-not-indexed-and-enroll-Copy-3",
    transform: "translate(-705.000000, -329.000000)",
    fill: "#8EC44A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-created-success",
    transform: "translate(546.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.971154,112.536058 L184.492788,99.0144231 L182.365385,96.8149038 L170.971154,108.245192 L165.634615,102.872596 L163.507212,105 L170.971154,112.536058 Z M174,90 C176.740398,90 179.276431,90.6850893 181.608173,92.0552885 C183.8678,93.3533719 185.646628,95.1322002 186.944712,97.3918269 C188.314911,99.7235694 189,102.259602 189,105 C189,107.740398 188.314911,110.276431 186.944712,112.608173 C185.646628,114.8678 183.8678,116.646628 181.608173,117.944712 C179.276431,119.314911 176.740398,120 174,120 C171.259602,120 168.723569,119.314911 166.391827,117.944712 C164.1322,116.62259 162.353372,114.831742 161.055288,112.572115 C159.685089,110.240373 159,107.71636 159,105 C159,102.28364 159.685089,99.759627 161.055288,97.4278846 C162.37741,95.1682579 164.168258,93.3774105 166.427885,92.0552885 C168.759627,90.6850893 171.28364,90 174,90 Z",
    id: "Success-icon"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.60c214c7ff2a3f62ac905dfca83fa66d.svg";
export { ForwardRef as ReactComponent };